import React, { useState } from 'react';
import CourseEditForm, { EditProgram } from '../../course-edit-form/CourseEditForm';
import { useEditCourse } from '../useEditCourse';
import { useUpdateProgramMutation, EditProgramFragmentDoc } from '@src/api/graphql-codegen';
import { useToast } from '@src/hooks/useToast';
import { logger } from '../../../../../utils/logger';

function EditProgramContent() {
  const { program } = useEditCourse();
  const [updateLoading, setUpdateLoading] = useState(false);
  const { successToast } = useToast();

  const [updateProgram ] = useUpdateProgramMutation({
    onCompleted() {
      successToast("Course is successfully updated!");
      setUpdateLoading(false);
    },
    update(cache, res) {
      const d = res?.data?.updateProgram;
      if (d) {
        cache.writeFragment({
          id: cache.identify(d),
          data: { ...d },
          fragment: EditProgramFragmentDoc
        });
      }
    },
    onError(e) {
      logger.debug(`[e]`, e);
    }
  });

  const handleEdit = async(p: EditProgram) => {
    try {
      setUpdateLoading(true);
      updateProgram({
        variables: {
          input: {
            id: p.id,
            name: p.name,
            image: p.image,
            description: p.description,
            grade: p.grade,
            isParentCourse: p.isParentCourse,
            country: p.country,
            coverVideo: p.coverVideo
          },
        }
      });
    } catch (e) {
      logger.debug(`[e]`, e);
      setUpdateLoading(false);
    }
  };

  return (
    <CourseEditForm course={program} onSave={handleEdit} loading={updateLoading}/>
  );
}

export default EditProgramContent;
